<template>
  <form @submit.prevent="save" id="my-account-user-invite">
    <div class="alert -success" v-if="finished">
      <p>Usuário foi confidado com sucesso. Ele receberá um email para criar uma senha!</p>
    </div>

    <div class="alert -danger" v-if="errors.unrecognized">
      <p>Ocorreu um erro desconhecido ao alterar as informações, por favor tente novamente.</p>
    </div>

    <div class="form-group">
      <label for="name" class="label">Nome</label>
      <input
        type="text"
        id="name"
        name="name"
        class="form-control"
        v-model="form.name"
        autocomplete="off"
        disabled
      >
    </div>

    <div class="form-group">
      <label for="email" class="label">E-mail</label>
      <input
        type="text"
        id="email"
        name="email"
        class="form-control"
        v-model="form.email"
        autocomplete="off"
        disabled
      >
    </div>

    <div class="form-group" :class="{ '-has-error': errors.form.role.length > 0 }">
      <label for="email" class="label">Permissão</label>
      <select
        id="role"
        name="role"
        class="form-control"
        v-model="form.role"
        required
      >
        <option value="1">Master</option>
        <option value="2">Operador</option>
      </select>
      <p class="description" v-if="errors.form.role.length > 0">{{ errors.form.role[0] }}</p>
    </div>

    <div class="flex" style="justify-content: flex-end">
      <button class="btn btn-default" type="button" @click="back">Voltar</button>
      <button class="btn btn-primary ml-2" type="submit">Salvar</button>
    </div>

    <loader v-if="loading"/>
  </form>
</template>

<script>
import Loader from '@/support/components/Loader.vue';
import checkErrorIsUnrecognizedResponse from '@/support/helpers/checkErrorIsUnrecognizedResponse';

export default {
  name: 'UserEdit',

  data() {
    return {
      loading: false,
      finished: false,
      form: {
        name: this.$route.params.user.name,
        email: this.$route.params.user.email,
        role: this.$route.params.user.role,
        id: this.$route.params.user.id,
      },
      errors: {
        unrecognized: false,
        form: {
          name: [],
          email: [],
          role: [],
        },
      },
    };
  },

  methods: {
    /**
     * Update the organization information.
     *
     * @returns {Promise<void>}
     */
    async save() {
      try {
        this.finished = false;
        this.loading = true;
        this.resetErrors();

        await this.$store.dispatch('auth/changeRole', {
          role: this.form.role,
          id: this.form.id,
        });

        this.finished = true;

        this.form.role = '';

        this.$notify({
          group: 'app',
          type: 'success',
          title: 'Sucesso!',
          text: 'Permissão alterada com sucesso.',
        });

        this.back();
      } catch (err) {
        if (checkErrorIsUnrecognizedResponse(err, [422])) {
          this.errors.unrecognized = true;
          return;
        }

        const { data, status } = err.response;

        if (status === 422) {
          this.errors.form.role = data.errors.role || [];
        }
      } finally {
        this.loading = false;
      }
    },

    back() {
      this.$router.back();
    },

    /**
     * Reset the errors page.
     */
    resetErrors() {
      this.errors.form.role = [];
      this.errors.unrecognized = false;
    },
  },

  directives: {
  },

  components: {
    Loader,
  },
};
</script>

<style scoped>

</style>
